import { render, staticRenderFns } from "./ConsultarCDA.vue?vue&type=template&id=ee1511a6&"
import script from "./ConsultarCDA.vue?vue&type=script&lang=js&"
export * from "./ConsultarCDA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports